import React, { useEffect } from "react";
import { Table  } from 'antd';
import { connect } from "react-redux";
import { 
    getTrainingClassModuleList, doTrainingClassModuleDelete
} from "../../../../../redux/trainingclass/trainingClassState";
import { handleTableChange } from "utils";
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import PopupButton from "components/button/PopupButton";
import TrainingClassModuleForm from "./TrainingClassModuleForm";


const TrainingClassModuleTable = ({ recordList, pagination, doSearch, filters, doDelete, classeId }) => {

    const columns = [
        
        {
            title: 'Module Name',
            dataIndex: 'module_name', 
            key: 'module_name',
            
            render: ( module_name ) => (
                <span>{module_name}</span>
            ),      
        },

        {
	       title: <PopupButton id="add_class_module" title="Add Class Module" label="Add" btnClass="btn-small" modalWidth={600}>
						<TrainingClassModuleForm recordId={0} mode="edit" classeId={classeId} />
					</PopupButton>,
	        dataIndex: 'tcm_id',
	        key: 'tcm_id',
	        width: '12%',
	        render:(_, record) => <CrudOption 
                                    baseRoute={`/console/training-classes/${classeId}/training-class-modules`} 
                                    recordId={record?.tcm_module_id} 
                                    allowEdit={false}
                                    deleteHandler={() => doDelete({
                                        tcm_module_id: record?.tcm_module_id,
                                        tcm_id: record?.tcm_id,
                                    })} 
                                />
	    },
    ]   
	
    
    useEffect(() => {
        if (classeId) {
            doSearch({paginate: pagination.per_page, classeId});
        } 
    }, [doSearch, classeId]);

    return (   
        <Card extra={"w-full h-full"}>
            <div className="h-full overflow-x-scroll xl:overflow-x-hidden">
                <Table
                    dataSource={recordList} 
                    columns={columns} 
                    rowKey={(record) => record.tcm_id}
                    pagination={{...pagination, 
                        showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
                    onChange={handleTableChange(doSearch, filters)}                  	
                />
            </div>
        </Card>
    );
};

const mapStateToProps = (state) => ({
  recordList: state.trainingClass.trainingClassModuleList?.items,
  pagination: state.trainingClass.trainingClassModuleList?.pagination,
  filters: state.trainingClass.trainingClassModuleList?.filters,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getTrainingClassModuleList(filters)),
    doDelete: (id) => dispatch(doTrainingClassModuleDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingClassModuleTable);
